import React, { useState, useMemo } from 'react';
import { Pressable, Platform, StyleSheet, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import useTranslation from '@/hooks/useTranslation';
import Text from '@/components/Typography/Text';
import Switch from '@/components/Inputs/Switch';

const createStyles = (colors) => StyleSheet.create({
  rowButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    minHeight: 30,
    paddingVertical: 5,
    paddingHorizontal: 12,
    borderRadius: 4,
    marginVertical: 0,
    width: '100%',
    ...Platform.select({
      web: {
        cursor: 'pointer',
        transition: 'all 0.2s ease',
      }
    })
  },
  rowButtonHovered: {
    backgroundColor: colors.solid_color_tertiary,
  },
  rowButtonText: {
    color: colors.text_color_primary,
    fontSize: 14,
  },
});

const ToggleControl = ({ param, onChange }) => {
  const { colors } = useTheme();
  const { t } = useTranslation();
  const styles = useMemo(() => createStyles(colors), [colors]);
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <Pressable 
      style={[
        styles.rowButton,
        isHovered && styles.rowButtonHovered
      ]}
      onPress={() => onChange(!param.value)}
      onHoverIn={() => setIsHovered(true)}
      onHoverOut={() => setIsHovered(false)}
    >
      <Text style={styles.rowButtonText}>
        {param.value ? t('chatInput.toggle.enabled') : t('chatInput.toggle.disabled')}
      </Text>
      <Switch
        value={param.value}
        onValueChange={onChange}
      />
    </Pressable>
  );
};

export default ToggleControl;

